import { render } from "./IndexTransactionDetailPage.vue?vue&type=template&id=0e679167"
import script from "./IndexTransactionDetailPage.vue?vue&type=script&lang=js"
export * from "./IndexTransactionDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__